// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Ww","icon":"i_Wx","label":"i_Wy","text":"i_Wz"};